const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/v1/expo`;
export const expoAudioUrl = (token, download = false) => `${BASE}/listen/${encodeURIComponent(token)}/audio${download ? '?download=true' : ''}`;
export async function expoRequest(path, { token, body, method = 'GET' } = {}) {
  const multipart = body instanceof FormData;
  const response = await fetch(`${BASE}${path}`, { method, headers: {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(body && !multipart ? { 'Content-Type': 'application/json' } : {}),
  }, ...(body ? { body: multipart ? body : JSON.stringify(body) } : {}), referrerPolicy: 'no-referrer' });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(typeof data.detail === 'string' ? data.detail : data.message || data.detail?.message || 'Could not complete that step. Check your connection and retry.');
    error.code = data.code || data.detail?.code;
    error.status = response.status;
    throw error;
  }
  return data;
}
export const expoAdmin = (path, body, method = 'GET') => expoRequest(path, { token: localStorage.getItem('ltbb-ba-token'), body, method });
